<span>
  <div [class]="'tool-status-wrapper '">
    <div [class]="'tool-status ' + statusClassName">
      <span>{{ statusName }}</span>
    </div>
  </div>
</span>
